<mat-card class="logon_card">
  <mat-card-content>
    <form #loginForm="ngForm" (ngSubmit)="onSubmit()">
      <h2>Anmelden</h2>
      @if (!loginValid) {
        <mat-error>
          The username and password were not recognized
        </mat-error>
      }
      <mat-form-field class="fill_width">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="username" name="username" required>
        <mat-error>
          Email-Adresse
        </mat-error>
      </mat-form-field>
      <mat-form-field class="fill_width">
        <mat-label>Passwort</mat-label>
        <input matInput type="password" [(ngModel)]="password" name="password" required>
        <mat-error>
          Bitte gib ein gültiges Passwort an
        </mat-error>
      </mat-form-field>
      <mat-checkbox (change)="onRememberThisUserChange($event)" [checked]="rememberThisUser">
        Mit diesem Benutzer angemeldet bleiben
      </mat-checkbox>
      <br />
      <br />
      <table>
        <tr>
          <td style="width: 90%;">
            <a routerLink="/passwordresetemail">Passwort vergessen?</a>
          </td>
          <td style="text-align: right; width: 10%;">
            <button mat-raised-button color="primary" [disabled]="!loginForm.form.valid">Anmelden</button>
          </td>
        </tr>
      </table>
    </form>
  </mat-card-content>
</mat-card>